import React from 'react';

import PropTypes from 'prop-types';
import { Field } from 'formik';

import ErrorIcon from '../../../assets/images/icon_error_messages.gif';
import { Wrapper } from '../css';
import Label from './common/label';

const Email = ({ labels, errors, touched, ...rest }) => {
  return (
    <>
      <Label labelName={labels.EMAIL} />
      <div
        style={{ position: 'relative' }}
        className={`input-container ${
          errors.email && touched.email ? 'error' : ''
        }`}
      >
        <Field
          name="email"
          type="email"
          className="select-style"
          style={{ width: '100%' }}
          placeholder={labels.PLACEHOLDER_EMAIL}
          {...rest}
        />
        <>
          <div className="error_messages">
            <span className="frg-body-font-14px">{errors.email}</span>
          </div>
          <div id="username_error_icon" className="error_messages_icon">
            <img src={ErrorIcon} alt="error_icon" />
          </div>
        </>
      </div>

      <Wrapper>
        <div>
          <span className="frg-body-font-14px" style={{ fontWeight: 700 }}>
            {labels.NOTE}: {labels.EMAIL_MESSAGE}
          </span>
        </div>
      </Wrapper>
    </>
  );
};

Email.propTypes = {
  labels: PropTypes.isRequired,
  errors: PropTypes.isRequired,
  touched: PropTypes.func.isRequired
};

export default Email;
